import React, { useEffect, useState } from 'react';
import { LuNavigation } from 'react-icons/lu';
import ModalShell from './ModalShell';
import { desdeLinkGoogle, linkGoogleDe, linkWazeDe } from '../../utils/navegacion';

// Selector "¿Con qué app?" (29-oct-2026). Se monta una vez en App: escucha irA(...) y además intercepta
// cualquier link a Google Maps de UN lugar (Mapa, GPS, Cómo llegar) para ofrecer también Waze. Las rutas
// con varias paradas van directo a Google: Waze no las arma.
// Un link con data-sin-elegir va directo (el que ya está al lado de su botón de Waze).
export default function ElegirNavegacion() {
    const [op, setOp] = useState(null);   // { titulo, google, waze, paradas }

    useEffect(() => {
        const alPedir = (e) => {
            const { direccion, lat, lng, nombre } = e.detail || {};
            if (!direccion && lat == null) return;
            setOp({ titulo: nombre || direccion, google: linkGoogleDe(direccion, lat, lng), waze: linkWazeDe(direccion, lat, lng), paradas: 1 });
        };
        const alClic = (e) => {
            if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
            const a = e.target.closest && e.target.closest('a[href]');
            if (!a || a.hasAttribute('data-sin-elegir')) return;
            const d = desdeLinkGoogle(a.href);
            // Rutas con varias paradas: solo Google las arma (Waze lleva a un lugar por vez), van directo
            if (!d || d.paradas > 1) return;
            e.preventDefault();
            e.stopPropagation();
            setOp({ titulo: d.destino, ...d });
        };
        window.addEventListener('elegir-navegacion', alPedir);
        document.addEventListener('click', alClic, true);
        return () => { window.removeEventListener('elegir-navegacion', alPedir); document.removeEventListener('click', alClic, true); };
    }, []);

    if (!op) return null;
    const ir = (url) => { window.open(url, '_blank', 'noopener'); setOp(null); };
    return (
        <ModalShell titulo="¿Con qué app vas?" subtitulo={op.titulo} onCerrar={() => setOp(null)}>
            <div className="space-y-2">
                <button type="button" onClick={() => ir(op.google)}
                    className="w-full h-12 rounded-xl bg-brand-red text-white text-body font-black inline-flex items-center justify-center gap-2 active:scale-95">
                    <LuNavigation size={16} /> Google Maps{op.paradas > 1 ? ' (todas las paradas)' : ''}
                </button>
                <button type="button" onClick={() => ir(op.waze)}
                    className="w-full h-12 rounded-xl bg-[#33CCFF] text-[#0B2A3A] text-body font-black inline-flex items-center justify-center gap-2 active:scale-95">
                    <LuNavigation size={16} /> Waze{op.paradas > 1 ? ' (a la primera parada)' : ''}
                </button>
                {op.paradas > 1 && <p className="text-caption text-muted text-center">Waze no acepta varias paradas: te lleva a la primera.</p>}
            </div>
        </ModalShell>
    );
}
